module.exports = __webpack_public_path__ + "static/media/36-8.0139575d.mp3";